import React, {useContext, useState} from 'react';
import styles from './admin-layout.module.scss';
import * as Tabs from '@radix-ui/react-tabs';
import RoundButton from 'src/components/roundButton';
// @ts-ignore
import {Link} from 'react-router-dom';
import useStore from 'src/hooks/use-store';
import {MaintenanceContext} from './contexts';
import MaintenanceCreateForm from './create-form';
import I18nMessage from 'src/components/I18nMessage/index.jsx';
import classNames from 'classnames';
import {useIntl} from 'react-intl';

interface MaintenceAdminLayoutProps {
  children: [React.ReactElement, React.ReactElement, React.ReactElement, React.ReactElement];
}

const MaintenanceAdminLayout = ({children}: MaintenceAdminLayoutProps) => {
  const [activeTab, setActiveTab] = useState('registeredTab');
  const state = useContext(MaintenanceContext);
  const {store} = useStore();
  const {theme} = store;
  const intl = useIntl();

  const headerName = {
    'list': 'sharedMaintenance',
    'create': 'sharedCreateNew',
    'edit': 'sharedEdit',
    'realize': 'sharedRealize',
    // TODO: add a custom value to receive maintenance title - 'custom': () => string
  }[state.activeView];

  return (
    <div>

      <div className={styles.header}>
        <div className='float-left'>
          <h2 style={{color: theme}} className='form-title'>
            <I18nMessage id={headerName} />
          </h2>
        </div>
        {/* @ts-ignore */}
        <RoundButton className="mt-3 mb-3 float-right" tag={Link} to={'/admin'}>
          <span className="fas fa-times text-secondary" />
        </RoundButton>
      </div>

      {(() => {
        if (state.activeView === 'create') {
          return (
            <MaintenanceCreateForm />
          );
        }

        return (
          <div className={styles.tabsWrapper}>
            <Tabs.Root defaultValue='registeredTab' className={styles.tabs} onValueChange={(activeTab) => {
              setActiveTab(activeTab);
            }}>
              <Tabs.List className={styles.tabList}>
                  <Tabs.Trigger value="registeredTab" className={styles.tabTrigger}>
                    {intl.formatMessage({id: 'maintenanceRegisteredTabTitle'})}
                  </Tabs.Trigger>
                  <Tabs.Trigger value="upcomingTab" className={styles.tabTrigger}>
                    {intl.formatMessage({id: 'maintenanceUpcomingTabTitle'})}
                  </Tabs.Trigger>
                  <Tabs.Trigger value="ongoingTab" className={styles.tabTrigger}>
                    {intl.formatMessage({id: 'maintenanceOngoingTabTitle'})}
                  </Tabs.Trigger>
                  <Tabs.Trigger value="completed" className={styles.tabTrigger}>
                    {intl.formatMessage({id: 'maintenanceCompletedTabTitle'})}
                  </Tabs.Trigger>
              </Tabs.List>

              <Tabs.Content value="registeredTab" className={classNames(styles.tabContent, activeTab === 'registeredTab' && styles.noTabContentTopLeftBorderRadius)}>
                {children[0]}
              </Tabs.Content>

              <Tabs.Content value="upcomingTab" className={styles.tabContent}>
                {children[1]}
              </Tabs.Content>

              <Tabs.Content value="ongoingTab" className={styles.tabContent}>
                {children[2]}
              </Tabs.Content>

              <Tabs.Content value="completed" className={styles.tabContent}>
                {children[3]}
              </Tabs.Content>
            </Tabs.Root>
          </div>
        );
      })()}
    </div>

  );
};

export default MaintenanceAdminLayout;
